module.exports = __webpack_public_path__ + "img/btn_setting_more.d622a600.svg";